import { __decorate } from "tslib";
import { mixins } from 'vue-class-component';
import { Vue, Component } from 'vue-property-decorator';
import ConfirmationDialog from '@/components/ConfirmationDialog.vue';
import FormMixin from '@/helpers/vue_mixins/FormMixin';
import ShippingMethods from '@/plugins/graphql/queries/v2/shipping-methods.gql';
import ShippingMethodDelete from '@/plugins/graphql/mutations/v2/shipping-method-delete.gql';
import ShippingMethodPublish from '@/plugins/graphql/mutations/v2/shipping-method-publish-update.gql';
import { Getter, Mutation } from 'vuex-class';
import { successfulDestroy, successfulUpdate } from '@/helpers/mixins/LocalizationHelper';
import { ShippingMethodModel } from '@/helpers/entities/models/ShippingMethodModel';
import BaseOverlayLoader from '@/components/v2/BaseOverlayLoader';
import { ShippingMethodType } from '@/helpers/entities/enums/v2/ShippingMethodType';
import { ShippingMethodThirdPartyProvider } from '@/helpers/entities/enums/v2/ShippingMethodThirdPartyProvider';
import PaginatorMixin from '@/helpers/mixins/PaginatorMixin';
import { uniqBy } from 'lodash';
import GraphqlErrorMixin from '@/helpers/vue_mixins/GraphqlErrorMixin';
import ShopifyShippingRatesSynced from '@/plugins/graphql/subscriptions/v2/shopify-shipping-rates-synced.gql';
import RouterParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
import jntAllowedApp from '@/plugins/graphql/queries/v2/fetch-jnt-allowed-app.gql';
import Paginator from './Paginator.vue';
let ShippingMethodManager = class ShippingMethodManager extends mixins(FormMixin, GraphqlErrorMixin, PaginatorMixin, RouterParamsAppMixin) {
    constructor() {
        super(...arguments);
        this.shippingMethods = [];
        this.selectedShippingMethodUuid = null;
        this.thirdPartyShippingMethods = [
            // Uncomment these shipping methods if you want to make them available
            /* {
              uuid: '',
              name: 'XPOST.PH',
              price: 100,
              description: 'Coming Soon',
              published: false,
              customerInitiated: false,
              shippingType: this.internalShipping,
              thirdPartyProvider: null,
              pickupPoints: null,
              isThirdParty: true,
            },
            {
              uuid: '',
              name: this.mrSpeedy,
              price: 0,
              description: 'Same-Day Delivery service care of MrSpeedy.',
              published: false,
              customerInitiated: false,
              shippingType: this.thirdPartyShipping,
              thirdPartyProvider: this.mrSpeedyProvider,
              pickupPoints: null,
              isThirdParty: true,
            }, */
            {
                uuid: '',
                name: this.jntExpress,
                price: 0,
                description: 'Effortlessly manage your shipping needs with J&T Express. Ensure quick and reliable delivery to your customers across the country.',
                published: false,
                customerInitiated: false,
                shippingType: this.thirdPartyShipping,
                thirdPartyProvider: this.jntExpressProvider,
                pickupPoints: null,
                isThirdParty: true,
                hasBlankDimension: false,
                origin: 'chatgenie',
                zoneName: '',
                pickUpTimeSlot: null,
            },
            {
                uuid: '',
                name: this.pandago,
                price: 0,
                description: 'Select this option to offer PandaGo for same-day delivery.',
                published: false,
                customerInitiated: false,
                shippingType: this.thirdPartyShipping,
                thirdPartyProvider: this.pandagoProvider,
                pickupPoints: null,
                isThirdParty: true,
                hasBlankDimension: true,
                origin: 'chatgenie',
                zoneName: '',
                pickUpTimeSlot: null,
            },
            {
                uuid: '',
                name: this.grabExpress,
                price: 0,
                description: 'Select this option to offer GrabExpress for same-day delivery.',
                published: false,
                customerInitiated: false,
                shippingType: this.thirdPartyShipping,
                thirdPartyProvider: this.grabExpressProvider,
                pickupPoints: null,
                isThirdParty: true,
                hasBlankDimension: true,
                origin: 'chatgenie',
                zoneName: '',
                pickUpTimeSlot: null,
            },
            /* {
              uuid: '',
              name: this.lalamove,
              price: 0,
              description: 'Select this option to offer Lalamove for same-day delivery.',
              published: false,
              customerInitiated: false,
              shippingType: this.thirdPartyShipping,
              thirdPartyProvider: this.lalamoveProvider,
              pickupPoints: null,
              isThirdParty: true,
              hasBlankDimension: false,
              origin: 'chatgenie',
              zoneName: '',
              pickUpTimeSlot: null,
            }, */
            {
                uuid: '',
                name: this.ninjaVan,
                price: 0,
                description: 'Ninja Van riders pick up orders from their pickup location and deliver them to their customers within 3 to 5 days.',
                published: false,
                customerInitiated: false,
                shippingType: this.thirdPartyShipping,
                thirdPartyProvider: this.ninjaVanProvider,
                pickupPoints: null,
                isThirdParty: true,
                hasBlankDimension: false,
                origin: 'chatgenie',
                zoneName: '',
                pickUpTimeSlot: null,
            },
        ];
        // get filteredThirdPartyShippingMethods() {
        //   if (this.jntAllowedApp === false) {
        //     return this.thirdPartyShippingMethods.filter((method) => method.name !== this.jntExpress);
        //   }
        //   return this.thirdPartyShippingMethods;
        // }
        // private jntAllowedApp: boolean | null = null;
    }
    refetchShippingMethods() {
        this.$apollo.queries.shippingMethods.refetch();
    }
    get mrSpeedy() {
        return 'MrSpeedy';
    }
    get grabExpress() {
        return 'Grab Express';
    }
    get lalamove() {
        return 'Lalamove';
    }
    get pandago() {
        return 'PandaGo';
    }
    get ninjaVan() {
        return 'Standard Delivery by Ninja Van';
    }
    get jntExpress() {
        return 'J&T Express';
    }
    get internalShipping() {
        return ShippingMethodType.Internal;
    }
    get thirdPartyShipping() {
        return ShippingMethodType.ThirdParty;
    }
    get mrSpeedyProvider() {
        return ShippingMethodThirdPartyProvider.MrSpeedy;
    }
    get grabExpressProvider() {
        return ShippingMethodThirdPartyProvider.GrabExpress;
    }
    get lalamoveProvider() {
        return ShippingMethodThirdPartyProvider.Lalamove;
    }
    get pandagoProvider() {
        return ShippingMethodThirdPartyProvider.PandaGo;
    }
    get ninjaVanProvider() {
        return ShippingMethodThirdPartyProvider.NinjaVan;
    }
    get jntExpressProvider() {
        return ShippingMethodThirdPartyProvider.JntExpress;
    }
    get staticMrSpeedy() {
        return this.thirdPartyShippingMethods.filter((s) => s.name === this.mrSpeedy && !s.uuid)[0];
    }
    get fetchAppHasBlankDimension() {
        return this.shippingMethods[0].hasBlankDimension;
    }
    get staticGrabExpress() {
        return this.thirdPartyShippingMethods.filter((s) => s.name === this.grabExpress && !s.uuid)[0];
    }
    get staticLalamove() {
        return this.thirdPartyShippingMethods.filter((s) => s.name === this.lalamove && !s.uuid)[0];
    }
    get staticPandaGo() {
        return this.thirdPartyShippingMethods.filter((s) => s.name === this.pandago && !s.uuid)[0];
    }
    get staticNinjaVan() {
        return this.thirdPartyShippingMethods.filter((s) => s.name === this.ninjaVan && !s.uuid)[0];
    }
    get staticJntExpress() {
        return this.thirdPartyShippingMethods.filter((s) => s.name === this.jntExpress && !s.uuid)[0];
    }
    get shippingWithStaticData() {
        const mrSpeedy = this.shippingMethods.filter((s) => s.name === this.mrSpeedy && s.uuid)[0];
        const grabExpress = this.shippingMethods.filter((s) => s.name === this.grabExpress && s.uuid)[0];
        const lalamove = this.shippingMethods.filter((s) => s.name === this.lalamove && s.uuid)[0];
        const pandago = this.shippingMethods.filter((s) => s.name === this.pandago && s.uuid)[0];
        const ninjaVan = this.shippingMethods.filter((s) => s.name === this.ninjaVan && s.uuid)[0];
        const jntExpress = this.shippingMethods.filter((s) => s.name === this.jntExpress && s.uuid)[0];
        if (mrSpeedy) {
            const index = this.shippingMethods.indexOf(mrSpeedy);
            // Set to empty object to trigger reactivity
            this.shippingMethods.splice(index, 1);
        }
        if (grabExpress) {
            const grabIndex = this.findShippingIndex(this.staticGrabExpress?.name);
            this.thirdPartyShippingMethods[grabIndex] = grabExpress;
        }
        if (lalamove) {
            lalamove.hasBlankDimension = this.fetchAppHasBlankDimension;
            const lalamoveIndex = this.findShippingIndex(this.staticLalamove?.name);
            this.thirdPartyShippingMethods[lalamoveIndex] = lalamove;
        }
        if (pandago) {
            const pandaGoIndex = this.findShippingIndex(this.staticPandaGo?.name);
            this.thirdPartyShippingMethods[pandaGoIndex] = pandago;
        }
        if (ninjaVan) {
            ninjaVan.hasBlankDimension = this.fetchAppHasBlankDimension;
            const ninjavanIndex = this.findShippingIndex(this.staticNinjaVan?.name);
            this.thirdPartyShippingMethods[ninjavanIndex] = ninjaVan;
        }
        if (jntExpress) {
            const jntIndex = this.findShippingIndex(this.staticJntExpress?.name);
            this.thirdPartyShippingMethods[jntIndex] = jntExpress;
        }
        const thirdPartyShippingMethodsOnly = this.shippingMethods.filter((method) => method.shippingType === 'third_party');
        const deduplicatedShippingMethods = [
            ...this.thirdPartyShippingMethods,
            ...thirdPartyShippingMethodsOnly,
        ];
        const uniqueThirdPartyShipping = uniqBy(deduplicatedShippingMethods, 'name');
        const manualShippingMethods = this.shippingMethods.filter((method) => method.shippingType !== 'third_party');
        const shippingMethods = [...uniqueThirdPartyShipping, ...manualShippingMethods];
        return shippingMethods;
    }
    findShippingIndex(shippingName) {
        return this.thirdPartyShippingMethods.findIndex((obj) => obj.name === shippingName);
    }
    get availableShipping() {
        const methods = this.shippingWithStaticData.filter((method) => method.uuid !== '');
        return uniqBy(methods, 'name');
    }
    get queryOnFlight() {
        return this.$apollo.queries.shippingMethods.loading;
    }
    unpublishThirdParty(shipping) {
        if (shipping) {
            const index = this.thirdPartyShippingMethods.findIndex(({ name }) => shipping.name === name);
            const shippingMethod = { ...shipping, published: false };
            this.$set(this.thirdPartyShippingMethods, index, {});
            this.$nextTick(() => {
                this.$set(this.thirdPartyShippingMethods, index, shippingMethod);
            });
        }
    }
    resetShippingStatus() {
        const mrSpeedy = this.shippingMethods.filter((s) => s.name === this.mrSpeedy && s.uuid)[0];
        if (mrSpeedy) {
            const index = this.shippingMethods.indexOf(mrSpeedy);
            // Set to empty object to trigger reactivity
            Vue.set(this.shippingMethods, index, { ...mrSpeedy, published: null });
            Vue.nextTick(() => {
                Vue.set(this.shippingMethods, index, mrSpeedy);
            });
        }
    }
    toggleConfirmation(uuid) {
        this.selectedShippingMethodUuid = uuid;
        this.showConfirmationDialog();
    }
    goToShippingDetailsPage(uuid) {
        this.$router.push({
            name: 'ecommerce-shipping-edit',
            params: {
                uuid,
            },
        });
    }
    async togglePublishUpdate(publish, shippingMethodUuid) {
        this.requestOnFlight();
        await this.$apollo
            .mutate({
            mutation: ShippingMethodPublish,
            variables: {
                input: {
                    shippingMethodUuid,
                    publish: publish || false,
                },
            },
        })
            .then(() => {
            const msg = successfulUpdate('Shipping');
            this.successNotification(msg);
        })
            .catch((e) => {
            this.errorNotification(e.message);
        })
            .finally(() => {
            this.requestDone();
        });
    }
    async uponConfirm() {
        this.requestOnFlight();
        await this.delete()
            .then(() => {
            const msg = successfulDestroy('Shipping');
            this.successNotification(msg);
        })
            .catch((e) => {
            this.errorNotification(e.message);
        })
            .finally(() => {
            this.requestDone();
            this.hideConfirmationDialog();
        });
    }
    async delete() {
        const { appUuid } = this;
        if (this.selectedShippingMethodUuid) {
            await this.$apollo.mutate({
                mutation: ShippingMethodDelete,
                variables: {
                    input: {
                        shippingMethodUuid: this.selectedShippingMethodUuid,
                    },
                },
                update: (cache, { data }) => {
                    const { shippingMethod } = data.shippingMethodDelete;
                    const queryOptions = {
                        query: ShippingMethods,
                        variables: {
                            appUuid,
                        },
                    };
                    const { fetchAllShippingMethod } = cache.readQuery({
                        ...queryOptions,
                    });
                    const deletedShippingMethod = (sm) => {
                        return sm.node.uuid !== shippingMethod.uuid;
                    };
                    cache.writeQuery({
                        ...queryOptions,
                        data: {
                            fetchAllShippingMethod: {
                                ...fetchAllShippingMethod,
                                edges: fetchAllShippingMethod.edges.filter(deletedShippingMethod),
                            },
                        },
                    });
                },
            });
        }
    }
};
__decorate([
    Getter('appUuid')
], ShippingMethodManager.prototype, "appUuid", void 0);
__decorate([
    Mutation('showConfirmationDialog')
], ShippingMethodManager.prototype, "showConfirmationDialog", void 0);
__decorate([
    Mutation('hideConfirmationDialog')
], ShippingMethodManager.prototype, "hideConfirmationDialog", void 0);
ShippingMethodManager = __decorate([
    Component({
        apollo: {
            shippingMethods: {
                query: ShippingMethods,
                variables() {
                    return {
                        appUuid: this.appUuid,
                        first: this.perPage,
                        after: this.startCursor,
                    };
                },
                update(data) {
                    const { pageInfo, totalCount } = data.fetchAllShippingMethod;
                    let { edges } = data.fetchAllShippingMethod;
                    // remove lalamove
                    edges = edges.filter((edge) => edge.node.thirdPartyProvider !== 'lalamove');
                    const shippingMethodNodes = (shipping) => {
                        return new ShippingMethodModel(shipping.node);
                    };
                    this.pageInfo = pageInfo;
                    this.totalCount = totalCount;
                    return edges.map(shippingMethodNodes);
                },
                fetchPolicy: 'cache-and-network',
                subscribeToMore: {
                    document: ShopifyShippingRatesSynced,
                    variables() {
                        return {
                            appUuid: this.baseAppUUID,
                            first: this.perPage,
                            after: this.startCursor,
                        };
                    },
                    updateQuery(prev) {
                        this.$apollo.queries.shippingMethods.refetch();
                        return prev;
                    },
                },
            },
            jntAllowedApp: {
                query: jntAllowedApp,
                variables() {
                    return {
                        appUuid: this.appUuid,
                    };
                },
                update(data) {
                    const { fetchJntAllowedApp } = data;
                    this.jntAllowedApp = fetchJntAllowedApp;
                    if (!this.jntAllowedApp) {
                        this.thirdPartyShippingMethods = this.thirdPartyShippingMethods.filter((method) => method.name !== this.jntExpress);
                    }
                },
                fetchPolicy: 'cache-and-network',
            },
        },
        components: {
            ConfirmationDialog,
            BaseOverlayLoader,
            Paginator,
        },
    })
], ShippingMethodManager);
export default ShippingMethodManager;
